module.exports = __webpack_public_path__ + "b67134b4df53afdfcd5565f5bb031c9f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 554
// module chunks = 0